import script from "./CloudInstancesList.vue?vue&type=script&setup=true&lang=js"
export * from "./CloudInstancesList.vue?vue&type=script&setup=true&lang=js"

import "./CloudInstancesList.vue?vue&type=style&index=0&id=d24a2f5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d24a2f5a"]])

export default __exports__